/**
 * Sort Sync - Sincroniza selects de sort desktop/mobile
 */

function syncSortSelects() {
  const desktopSort = document.getElementById('SortBy');
  const mobileSort = document.getElementById('SortBy-mobile');
  
  if (desktopSort && mobileSort) {
    mobileSort.value = desktopSort.value;
  }
}

document.addEventListener('change', function(e) {
  if (e.target.id === 'SortBy-mobile') {
    const desktopSort = document.getElementById('SortBy');
    if (desktopSort) {
      desktopSort.value = e.target.value;
      desktopSort.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  
  if (e.target.id === 'SortBy') {
    const mobileSort = document.getElementById('SortBy-mobile');
    if (mobileSort) {
      mobileSort.value = e.target.value;
    }
  }
});

if (typeof FacetFiltersForm !== 'undefined') {
  const originalRenderPage = FacetFiltersForm.renderPage;
  FacetFiltersForm.renderPage = function(...args) {
    originalRenderPage.apply(this, args);
    setTimeout(syncSortSelects, 100);
  };
}

document.addEventListener('DOMContentLoaded', syncSortSelects);